<template>
  <div class="grid-x text-left grid-y2">
    <span class="contact">
      Contact
    </span>
    <Panel 
      title="Contact" 
      content="Lorem ipsum dolor labore et dolore magna aliqua. Ut enim adrcitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
      
      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
      
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
      width="40"
      height="30"
      posX="1400"
    />
  </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    msg: String
  }
}
</script>

<style scoped>

</style>
